import BaseExtensionService from '@src/slide/application/service/edit-extension/core/base';
import {
    IBaseEditorExtensionService,
    IBaseEditorExtensionServiceDelegates,
} from '@src/slide/application/service/edit-extension/core/editor/base/interface';
import { Scope } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';

/**
 * 主页面入口扩展的extension service
 */
export default class BaseEditorExtensionService extends BaseExtensionService
    implements IBaseEditorExtensionService {
    declare protected services: IBaseEditorExtensionServiceDelegates;

    /**
     * 修改编辑状态
     * @param state
     */
    public setEditState(state: PPTEditorStateEnumType): void {
        if (!this.services.userPriviledgeService) return;
        this.services.userPriviledgeService.setPPTEditorState({ state, scope: Scope.CURRENT });
    }

    /**
     * 注册编辑区侧边栏模块
     * @param module
     */
    public registerRightSideBarModule(module): void {
        this.services.rightSideBarService?.registerModule(module);
    }

    /**
     * 显示指定模块右边栏
     * @param moduleName 模块名称
     * @param params
     */
    public showRightSideBar(moduleName: string, params?: any): void {
        this.onRightSideBarMount(() => {
            this.services.rightSideBarService?.show(moduleName, params);
        });
    }

    /**
     * 是否显示右边栏
     * @param moduleName
     * @returns
     */
    public isShowRightSideBar(moduleName: string): boolean {
        return !!this.services.rightSideBarService?.isShown(moduleName);
    }

    /**
     * 隐藏右边栏
     */
    public hideRightSideBar(): void {
        this.services.rightSideBarService?.hide();
    }

    /**
     * 获取侧边栏正显示的模块名称
     */
    public getDisplayRightSlideBarName(): string {
        return this.services.rightSideBarService?.displayingModuleName() || '';
    }

    private onRightSideBarMount(callback: () => void) {
        const isMount = () => !!document.getElementById('rs-bar-container');
        if (isMount()) {
            // 这里函数设计为 callback 模式而不是 async 函数，
            // 是为了防止之前依赖同步执行的代码出现问题。
            callback();
            return;
        }

        return (async () => {
            // 启动时立即出发该函数时，侧边栏尚未 mount，导致 RightSideBar（超远古代码）单例未初始化。
            // 此时需要轮询等待侧边栏 mount，否则无法正常弹出侧边栏。
            // TODO: 这里更好的模式是状态驱动模式，但是目测改动量较大，留待后续重构吧。
            while (!isMount()) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        })().then(callback);
    }
}
